var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "callback-layout" } }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c("p", { staticClass: "headline-large gray" }, [
          _vm._v("Chargement en cours..."),
        ]),
        _c("maSpinner"),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }